export default "__VITE_ASSET__BI1vmp5y__"